export enum ConversationSelectType {
  EXISTING = 'EXISTING',
  NEW = 'NEW',
}
